import { registerGTMEvent } from "../registerGTMEvent/registerGTMEvent";

export const addVPSAddon =
  (id, gtmData) =>
  async (dispatch, getState, { api }) =>
    api.addVPS(id).then(
      (isSuccess) => {
        if (isSuccess) {
          dispatch(
            registerGTMEvent.addToCart({
              type: "addonProduct",
              // location: "In-cart upsell", // unused for GTM at the moment
              product: gtmData,
            }),
          );
        }
        return isSuccess;
      },
      (err) => {
        console.error("Adding VPS product to the basket failed", err);
      },
    );
